<template>
  <section class="listing">
    <div class="header">
      <div class="title">Faturamento</div>
      <!-- <button @click="print" class="button-save"><i class="fas fa-print"></i><span>Imprimir</span></button> -->
    </div>
    <form @submit.prevent class="form form-search">
      <input v-model="iniDate" @change="getData" type="date" />
      <input v-model="endDate" @change="getData" type="date" />
      <input v-model="search" type="text" placeholder="Pesquisar..." />
    </form>
    <div class="print-header">
      <div class="print-title">Faturamento</div>
    </div>
    <transition name="show" mode="out-in">
      <i v-if="loading" class="fas fa-spinner loading-big"></i>
      <div v-if="!loading" style="margin-top: 10px">
        <div class="sum-group">
          <div class="sum">
            <span>Total descontado</span>
            <span>{{ total.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) }}</span>
          </div>
          <div class="sum">
            <span>Transações</span>
            <span>{{ transactions.length }}</span>
          </div>
          <div class="sum">
            <span>Válidos</span>
            <span>{{ transactionsOK.length }}</span>
          </div>
          <div class="sum">
            <span>Cancelados</span>
            <span>{{ transactions.length - transactionsOK.length }}</span>
          </div>
        </div>
        <!-- <div class="sum-group" style="margin-bottom: 10px">
          <div class="sum sum2">
            <span>Ticket Médio</span>
            <span>{{ average.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) }}</span>
          </div>
          <div class="sum">
            <span>Comissão</span>
            <span>{{ commission.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) }}</span>
          </div>
        </div> -->
        <div class="list-cards">
        <div v-for="(t, i) in filtered" :key="i" class="list">
          <div v-if="i > 0 ? getDay(t.date) !== getDay(filtered[i - 1].date) : true" class="calendar">
            <span>{{ getDay(t.date) }}</span>
            <span>{{ getMonthText(t.date) }}</span>
          </div>
          <div v-else class="calendar-spacer"></div>
          <div class="data">
            <div class="main-data">{{ t.customer }}</div>
            <div class="detail-data">{{ t.product }}</div>
          </div>
          <div class="list-meta">
            <div class="main-data">{{ t.refundAmount ? (t.amount - t.refundAmount).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) : t.amount.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) }}</div>
            <div class="detail-data">{{ t.status === 'refunded' ? 'ESTORNADO' : '' }}</div>
          </div>
          <div class="actions">
            <button v-if="t.status !== 'refunded'" @click="refund = t" class="button-action">
              <i class="fas fa-undo"></i><span>ESTORNAR</span>
            </button>
          </div>
        </div>
        </div>
      </div>
    </transition>
    <TransactionRefund v-if="refund" :transaction="refund" :close="() => {
      this.refund = null
      this.getData()
    }" />
    <UserTicket v-if="detail" :transaction="detail.id" :showDate="detail.dateshow" :close="() => this.detail = null"/>
  </section>
</template>

<script>
import logger from '../../logger'
import { getAll } from '../api/transaction'
import TransactionRefund from './TransactionRefund.vue'
import UserTicket from './UserTicket.vue'

export default {
  components: { TransactionRefund, UserTicket },
  data () {
    return {
      loading: true,
      transactions: [],
      iniDate: null,
      endDate: null,
      refund: null,
      search: '',
      detail: null
    }
  },
  computed: {
    filtered () {
      return this.transactions.filter(x => Object.keys(x).some(key => String(x[key]).toUpperCase().includes(this.search.toUpperCase())))
    },
    transactionsOK () {
      return this.filtered.filter(x => x.status !== 'refunded')
    },
    total () {
      return this.transactionsOK.map(x => Number(x.amount)).reduce((acc, cur) => acc + cur, 0)
    },
    average () {
      return this.filtered.length ? this.total / this.filtered.length : 0
      // const amount = this.transactions.map(x => Number(x.amount)).reduce((acc, cur) => acc + cur, 0)
      // const tickets = this.transactions.map(x => Number(x.tickets)).reduce((acc, cur) => acc + cur, 0)
      // return amount === 0 ? 0 : amount / tickets
    },
    commission () {
      return this.total > 0 ? this.total - this.total / 1.18 : 0
    }
  },
  watch: {
    refund (value) {
      if (!value) this.getData()
    }
  },
  async mounted () {
    try {
      const dateIni = new Date()
      const dateFim = new Date()
      dateFim.setMonth(dateFim.getMonth() + 1)
      dateFim.setDate(1)
      dateFim.setDate(dateFim.getDate() - 1)
      this.endDate = dateFim.toISOString().split('T')[0]

      dateIni.setDate(1)
      // date.setDate(date.getDate() - 90)
      this.iniDate = dateIni.toISOString().split('T')[0]
      this.getData()
    } catch (error) {
      logger.error(error)
    }
  },
  methods: {
    async getData () {
      this.loading = true
      try {
        const transactions = await getAll(this.iniDate, this.endDate)
        this.transactions = transactions || []
      } catch (error) {
        logger.error(error)
      }
      this.loading = false
    },
    print () {
      window.print()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";

.print-header {
  display: none;
  justify-content: space-between;
  align-items: center;
  border-bottom: 5px solid $primary-color;
  padding: 20px 15px;
  margin-bottom: 20px !important;
}

.print-title {
  font-size: 2em;
  color: $primary-color;
  font-weight: 500;
}

@media print {
  .admin-router {
    margin: 0;
  }
  .print-header {
    display: block;
  }
  .header, .form-search {
    display: none !important;
  }
  .list {
    page-break-inside: avoid;
    page-break-after: auto;
  }
}
</style>
